// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IValidationType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class ValidationType implements IValidationType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Error ValidationType
	**/
    get Error(): IValidationType {
        return this.FromId(1);
    }
    /**
		Returns Confirmation Warning ValidationType
	**/
    get ConfirmationWarning(): IValidationType {
        return this.FromId(2);
    }
    /**
		Returns Information ValidationType
	**/
    get Information(): IValidationType {
        return this.FromId(3);
    }
    /**
		Returns Override ValidationType
	**/
    get Override(): IValidationType {
        return this.FromId(4);
    }
    /**
		Returns Approval ValidationType
	**/
    get Approval(): IValidationType {
        return this.FromId(5);
    }
    /**
		Returns Warning ValidationType
	**/
    get Warning(): IValidationType {
        return this.FromId(6);
    }
    /**
		Returns NMVTIS Error ValidationType
	**/
    get NMVTISError(): IValidationType {
        return this.FromId(7);
    }
    /**
		Returns Overridable Satisfy Compliance ValidationType
	**/
    get OverridableSatisfyCompliance(): IValidationType {
        return this.FromId(8);
    }
    /**
		Returns MRP Approval ValidationType
	**/
    get MRPApproval(): IValidationType {
        return this.FromId(9);
    }
    /**
		Returns NMVTIS Validation Message ValidationType
	**/
    get NMVTISValidationMessage(): IValidationType {
        return this.FromId(10);
    }
    /**
		Returns Satisfy Compliance ValidationType
	**/
    get SatisfyCompliance(): IValidationType {
        return this.FromId(11);
    }
    /**
		Returns OIG Approval ValidationType
	**/
    get OIGApproval(): IValidationType {
        return this.FromId(12);
    }
    /**
		Returns Ignition Interlock Approval ValidationType
	**/
    get IgnitionInterlockApproval(): IValidationType {
        return this.FromId(14);
    }
    /**
		Returns CDL Approval ValidationType
	**/
    get CDLApproval(): IValidationType {
        return this.FromId(15);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'Error', displayValue: 'Error', description: 'Error', sortOrder: 999, active: true });
        this._dictionary.add('2', { id: 2, value: 'ConfirmationWarning', displayValue: 'Confirmation Warning', description: 'Confirmation Warning', sortOrder: 999, active: true });
        this._dictionary.add('3', { id: 3, value: 'Information', displayValue: 'Information', description: 'Information', sortOrder: 999, active: true });
        this._dictionary.add('4', { id: 4, value: 'Override', displayValue: 'Override', description: 'Override', sortOrder: 999, active: true });
        this._dictionary.add('5', { id: 5, value: 'Approval', displayValue: 'Approval', description: 'Approval', sortOrder: 999, active: true });
        this._dictionary.add('6', { id: 6, value: 'Warning', displayValue: 'Warning', description: 'Warning', sortOrder: 999, active: true });
        this._dictionary.add('7', { id: 7, value: 'NMVTISError', displayValue: 'NMVTIS Error', description: 'NMVTIS Error', sortOrder: 999, active: true });
        this._dictionary.add('8', { id: 8, value: 'OverridableSatisfyCompliance', displayValue: 'Overridable Satisfy Compliance', description: 'Overridable Satisfy Compliance', sortOrder: 999, active: true });
        this._dictionary.add('9', { id: 9, value: 'MRPApproval', displayValue: 'MRP Approval', description: 'MRP Approval', sortOrder: 999, active: true });
        this._dictionary.add('10', { id: 10, value: 'NMVTISValidationMessage', displayValue: 'NMVTIS Validation Message', description: 'For displaying validation messages from AIS', sortOrder: 999, active: true });
        this._dictionary.add('11', { id: 11, value: 'SatisfyCompliance', displayValue: 'Satisfy Compliance', description: 'Satisfy Compliance', sortOrder: 999, active: true });
        this._dictionary.add('12', { id: 12, value: 'OIGApproval', displayValue: 'OIG Approval', description: 'OIG Approval', sortOrder: 999, active: true });
        this._dictionary.add('14', { id: 14, value: 'IgnitionInterlockApproval', displayValue: 'Ignition Interlock Approval', description: 'Ignition Interlock Approval', sortOrder: 999, active: true });
        this._dictionary.add('15', { id: 15, value: 'CDLApproval', displayValue: 'CDL Approval', description: 'CDL Approval', sortOrder: 999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IValidationType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IValidationType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IValidationType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IValidationType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IValidationType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
